<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 9.41349C19.5 10.788 19.1216 12.0751 18.4621 13.1786C18.4302 13.2451 18.3932 13.3106 18.3507 13.3749L13.0186 21.4546C12.5388 22.1818 11.4612 22.1818 10.9814 21.4546L5.64927 13.3749C5.60685 13.3106 5.5698 13.2451 5.53792 13.1786C4.87843 12.0751 4.5 10.788 4.5 9.41349C4.5 5.31913 7.85786 2 12 2C16.1421 2 19.5 5.31913 19.5 9.41349ZM12 13.4609C14.2614 13.4609 16.0946 11.6488 16.0946 9.41349C16.0946 7.17819 14.2614 5.36612 12 5.36612C9.73862 5.36612 7.90541 7.17819 7.90541 9.41349C7.90541 11.6488 9.73862 13.4609 12 13.4609Z" fill="currentColor"/>
	</svg>
</template>

<script>
  export default {};
</script>
